import { SchemaFileDataGenericValidation } from "@rf/schemas/file-data-generic.schema";
import { array, string } from "yup";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import {
  checkTypeProperty,
  checkTypeRent,
  checkTypeSale,
  enumKeyFormPropery,
  fileIsRequiredWhenIsRent
} from "../helps";
import HCheckArray from "@rf-helper/check-have-value";
import { SchemaItemGeneric } from "@rf/schemas/item-generic.shema";

export const documentsBasicSchema = {
  // Lista de claves de documentos eliminados en modo edición
  remove_documents: array().of(string()).default([]).label("Documentos eliminados"),
  registration_number: string().default("").label("Número de registro"),
  have_mortgage_property: array()
    .of(SchemaItemGeneric)
    .default([])
    .label("Tiene hipoteca")
    .min(1, "Especifique si la propiedad tiene hipoteca"),
  notes_property: string()
    .default("")
    .label("Notas de la propiedad")
    .when([enumKeyFormPropery.typeProperty, "is_project"], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: [],
          projectTypeIds: []
        }),
      then: schema => schema.required("Las notas son requeridas"),
      otherwise: schema => schema
    }),

  file_title_property: array()
    .of(SchemaFileDataGenericValidation)
    .default([])
    .label("Título de propiedad")
    .when(
      [
        enumKeyFormPropery.isProject,
        "file_property_contract_property",
        enumKeyFormPropery.businessTypes
      ],
      {
        is: (
          isProject: boolean,
          file_property_contract_property: any[],
          businessTypes: I_GENERIC_ITEMS[]
        ) => {
          if (HCheckArray(file_property_contract_property)) {
            return false;
          }
          if (
            HCheckArray(businessTypes) &&
            checkTypeSale(businessTypes, isProject)
          ) {
            return true;
          }
          if (checkTypeRent(businessTypes, isProject)) {
            return fileIsRequiredWhenIsRent("file_title_property");
          }
          return true;
        },
        then: schema => schema.min(1, "Debe subir un documento de título"),
        otherwise: schema => schema
      }
    ),

  file_capture_details_property: array()
    .default([])
    .of(SchemaFileDataGenericValidation)
    .label("Detalle de captación")
    .when([enumKeyFormPropery.isProject, enumKeyFormPropery.businessTypes], {
      is: (isProject: boolean, businessTypes: I_GENERIC_ITEMS[]) => {
        if (checkTypeRent(businessTypes, isProject)) {
          return fileIsRequiredWhenIsRent("file_capture_details_property");
        }
        return true;
      },
      then: schema =>
        schema.min(1, "Debe subir un documento de detalle de captación"),
      otherwise: schema => schema
    }),

  file_owner_id_property: array()
    .of(SchemaFileDataGenericValidation)
    .default([])
    .label("Cédula del propietario")
    .when([enumKeyFormPropery.isProject, enumKeyFormPropery.businessTypes], {
      is: (isProject: boolean, businessTypes: I_GENERIC_ITEMS[]) => {
        if (checkTypeRent(businessTypes, isProject)) {
          return fileIsRequiredWhenIsRent("file_owner_id_property");
        }
        return true;
      },
      then: schema =>
        schema.min(1, "Debe subir un documento de cédula del propietario"),
      otherwise: schema => schema
    }),

  file_application_form_property: array()
    .of(SchemaFileDataGenericValidation)
    .default([])
    .label("Formulario de aplicación")
    .when([enumKeyFormPropery.isProject, enumKeyFormPropery.businessTypes], {
      is: (isProject: boolean, businessTypes: I_GENERIC_ITEMS[]) => {
        if (checkTypeRent(businessTypes, isProject)) {
          return fileIsRequiredWhenIsRent("file_application_form_property");
        }
        return true;
      },
      then: schema =>
        schema.min(1, "Debe subir un documento de formulario de aplicación"),
      otherwise: schema => schema
    }),

  file_power_ownership_property: array()
    .of(SchemaFileDataGenericValidation)
    .default([])
    .label("Poder de propiedad")
    .when([enumKeyFormPropery.isProject, enumKeyFormPropery.businessTypes], {
      is: (isProject: boolean, businessTypes: I_GENERIC_ITEMS[]) => {
        if (checkTypeRent(businessTypes, isProject)) {
          return fileIsRequiredWhenIsRent("file_power_ownership_property");
        }
        return false;
      },
      then: schema => schema.min(1, "Debe subir un documento de poder de propiedad"),
      otherwise: schema => schema
    }),

  file_commercial_registry_property: array()
    .of(SchemaFileDataGenericValidation)
    .default([])
    .label("Registro mercantil")
    .when([enumKeyFormPropery.isProject, enumKeyFormPropery.businessTypes], {
      is: (isProject: boolean, businessTypes: I_GENERIC_ITEMS[]) => {
        if (checkTypeRent(businessTypes, isProject)) {
          return fileIsRequiredWhenIsRent("file_commercial_registry_property");
        }
        return false;
      },
      then: schema => schema.min(1, "Debe subir un documento de registro mercantil"),
      otherwise: schema => schema
    }),
  file_property_contract_property: array()
    .of(SchemaFileDataGenericValidation)
    .default([])
    .label("Contrato de propiedad")
    .when([enumKeyFormPropery.isProject, enumKeyFormPropery.businessTypes], {
      is: (isProject: boolean, businessTypes: I_GENERIC_ITEMS[]) => {
        if (checkTypeRent(businessTypes, isProject)) {
          return fileIsRequiredWhenIsRent("file_property_contract_property");
        }
        return false;
      },
      then: schema =>
        schema.min(1, "Debe subir un documento de contrato de propiedad"),
      otherwise: schema => schema
    })
};
